class AgGridLicenceManager {
  private readonly _AG_LICENSE = 'Using_this_{AG_Grid}_Enterprise_key_{AG-077024}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Lendio}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Lendio_Lending_Platform}_only_for_{11}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{Lendio_Lending_Platform}_need_to_be_licensed___{Lendio_Lending_Platform}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{19_April_2026}____[v3]_[01]_MTc3NjU1MzIwMDAwMA==b5f5dd8698c832e2f6dab63eaf77f609';
  private _licenseProvided = false;

  getAgGridLicense(): string {
    if (this._licenseProvided) {
      throw new Error('Invalid license request');
    }
    this._licenseProvided = true;
    return this._AG_LICENSE;
  }
}

const agGridLicenseManager = new AgGridLicenceManager();

export const agGridLicense = {
  applyLicense: () => agGridLicenseManager.getAgGridLicense()
};
